import { z } from 'zod';
export const DocumentTemplateCategorySchema = z.enum([
    'PROPUESTA',
    'SOW',
    'NDA',
    'INFORME',
    'ESPECIFICACION_TECNICA',
    'CONTRATO',
    'CORREO',
    'OTRO',
]);
export const DocumentTemplateCategoryLabel = {
    PROPUESTA: 'Propuesta',
    SOW: 'SOW',
    NDA: 'NDA',
    INFORME: 'Informe',
    ESPECIFICACION_TECNICA: 'Especificación técnica',
    CONTRATO: 'Contrato',
    CORREO: 'Correo',
    OTRO: 'Otro',
};
export const RenderFormatSchema = z.enum(['md', 'pdf', 'docx']);
export const DocumentTemplateDtoSchema = z.object({
    id: z.string(),
    name: z.string(),
    category: DocumentTemplateCategorySchema,
    description: z.string().nullable(),
    body: z.string(),
    variables: z.unknown().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    createdByName: z.string().nullable(),
});
export const CreateDocumentTemplateSchema = z.object({
    name: z.string().min(2).max(200),
    category: DocumentTemplateCategorySchema.default('OTRO'),
    description: z.string().max(1000).nullable().optional(),
    body: z.string().min(1),
    variables: z.unknown().nullable().optional(),
});
export const UpdateDocumentTemplateSchema = CreateDocumentTemplateSchema.partial();
export const ApplyTemplateSchema = z.object({
    opportunityId: z.string(),
    format: RenderFormatSchema.default('pdf'),
    /** Sobrescribe el nombre del documento generado. */
    fileName: z.string().min(1).max(200).optional(),
});
export const PreviewTemplateSchema = z.object({
    /** Si se proporciona, las vars se llenan con datos de la oportunidad; si no, valores en blanco. */
    opportunityId: z.string().nullable().optional(),
    /** Si quieres previsualizar un body distinto al guardado (edición en vivo). */
    body: z.string().optional(),
});
export const TemplateVariableCatalogItemSchema = z.object({
    key: z.string(),
    description: z.string(),
});
export const DocumentTemplateListResponseSchema = z.object({
    items: z.array(DocumentTemplateDtoSchema),
    variableCatalog: z.array(TemplateVariableCatalogItemSchema),
});
//# sourceMappingURL=templates.js.map